/**
 * Quizz Bracelet Personnalisé — v2 « tunnel de vente »
 * - Parcours 7 écrans avec barre de progression et auto-avance
 * - Besoins dédoublonnés, vedettes + « Voir tous les besoins »
 * - Recommandation par scoring (couverture maximale des besoins)
 * - Pierre de naissance en upsell (signe astro)
 * - Résultat = mini fiche produit : maquette réaliste, tailles, prix -X%,
 *   timer d'offre, ajout au panier direct (même format que le configurateur)
 * - Email en filet après le résultat (Klaviyo)
 */
(function () {
  'use strict';

  if (window.__lpQuizzInit) return;
  window.__lpQuizzInit = true;

  var ZODIAC = {
    belier:     { stone: 'Jaspe Rouge',     label: 'Bélier',     arg: 'canalise ton énergie débordante' },
    taureau:    { stone: 'Quartz Rose',     label: 'Taureau',    arg: 'nourrit ton besoin de douceur et de stabilité' },
    gemeaux:    { stone: 'Citrine',         label: 'Gémeaux',    arg: 'éclaire ton esprit vif et curieux' },
    cancer:     { stone: 'Pierre de Lune',  label: 'Cancer',     arg: 'apaise ta grande sensibilité' },
    lion:       { stone: 'Pierre de Soleil',label: 'Lion',       arg: 'rayonne comme ton énergie naturelle' },
    vierge:     { stone: 'Amazonite',       label: 'Vierge',     arg: 'calme ton mental toujours en action' },
    balance:    { stone: 'Lapis Lazuli',    label: 'Balance',    arg: 'soutient ta quête d’équilibre et de vérité' },
    scorpion:   { stone: 'Obsidienne',      label: 'Scorpion',   arg: 'protège ton intensité émotionnelle' },
    sagittaire: { stone: 'Sodalite',        label: 'Sagittaire', arg: 'accompagne ta soif d’aventure et de sens' },
    capricorne: { stone: 'Onyx',            label: 'Capricorne', arg: 'ancre ta détermination' },
    verseau:    { stone: 'Améthyste',       label: 'Verseau',    arg: 'élève ton esprit libre et visionnaire' },
    poisson:    { stone: 'Aigue Marine',    label: 'Poissons',   arg: 'fluidifie ton monde intérieur et ton intuition' }
  };

  var SIZE_CONFIG = {
    '6mm': { '14cm': 26, '15cm': 27, '16cm': 29, '17cm': 31, '18cm': 33, '19cm': 34, '20cm': 36, '21cm': 38, '22cm': 40, '23cm': 42 },
    '8mm': { '14cm': 21, '15cm': 22, '16cm': 23, '17cm': 24, '18cm': 25, '19cm': 26, '20cm': 28, '21cm': 29, '22cm': 30, '23cm': 31 }
  };

  function init() {
    var quizz = document.querySelector('.quizz-wrapper');
    var dataEl = document.getElementById('quizz-data');
    if (!quizz || !dataEl) return;

    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { console.error('Quizz: données illisibles', e); return; }
    var STONES = DATA.stones || {};
    var SETTINGS = DATA.settings || {};
    var BRACELET_VARIANTS = DATA.braceletVariants || {};

    // Le formulaire Klaviyo est rendu en différé par le script Klaviyo :
    // on le cherche au moment de l'utiliser, jamais en avance
    function klForm() { return document.querySelector('[class*="klaviyo-form"]'); }

    // ---------------------------------------------------------------- état
    var state = {
      firstname: '',
      email: '',
      sex: '',
      illtype: '',
      needs: [],
      zodiac: '',
      stones: [],          // pierres de la proposition active (avec leurs besoins)
      proposals: [],       // les 2 compositions proposées
      proposal: 0,         // index de la proposition active
      astroAdded: false,
      beadSize: '6mm',
      braceletSize: '17cm'
    };
    try {
      var saved = JSON.parse(sessionStorage.getItem('quizzStateV2'));
      if (saved && saved.firstname !== undefined) state = Object.assign(state, saved);
    } catch (e) {}

    function save() { try { sessionStorage.setItem('quizzStateV2', JSON.stringify(state)); } catch (e) {} }

    // ------------------------------------------------------------ étapes
    var steps = Array.prototype.slice.call(quizz.querySelectorAll('[data-quizz-step]'));
    var finalStep = quizz.querySelector('[data-quizz-final]');
    var progress = quizz.querySelector('[data-quizz-progress]');
    var progressFill = quizz.querySelector('[data-quizz-progress-fill]');
    var progressLabel = quizz.querySelector('[data-quizz-progress-label]');
    var TOTAL_QUESTIONS = 6; // écrans 2 à 7 (prénom → email)

    var currentStep = 1;

    function showStep(n) {
      currentStep = n;
      steps.forEach(function (s) {
        var id = parseInt(s.getAttribute('data-quizz-step'), 10);
        s.hidden = id !== n;
        s.classList.toggle('is-in', id === n);
      });
      if (finalStep) finalStep.hidden = true;
      if (progress) {
        progress.hidden = n <= 1;
        var q = Math.max(0, n - 1);
        if (progressFill) progressFill.style.width = Math.round((q / (TOTAL_QUESTIONS + 1)) * 100) + '%';
        if (progressLabel) progressLabel.textContent = Math.min(q, TOTAL_QUESTIONS) + '/' + TOTAL_QUESTIONS;
      }
      var input = quizz.querySelector('[data-quizz-step="' + n + '"] input');
      if (input) setTimeout(function () { input.focus(); }, 250);
      if (n === 5) renderNeeds();
    }

    quizz.addEventListener('click', function (e) {
      var next = e.target.closest('[data-step-next]');
      if (next) { e.preventDefault(); tryAdvance(); return; }
      var back = e.target.closest('[data-step-back]');
      if (back) { e.preventDefault(); showStep(Math.max(1, currentStep - 1)); return; }
    });
    quizz.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('.quizz-input[name="firstname"]')) {
        e.preventDefault(); tryAdvance();
      }
    });

    function stepError(n, on) {
      var el = quizz.querySelector('[data-quizz-step="' + n + '"]');
      if (el) el.classList.toggle('has-error', !!on);
    }

    function tryAdvance() {
      if (currentStep === 1) { showStep(2); return; }
      if (currentStep === 2) {
        var input = quizz.querySelector('input[name="firstname"]');
        var v = (input && input.value || '').trim();
        if (!v) { stepError(2, true); return; }
        stepError(2, false);
        state.firstname = v;
        quizz.querySelectorAll('[data-quizz-firstname]').forEach(function (el) { el.textContent = v; });
        pushKlaviyo('first_name', v);
        save(); showStep(3); return;
      }
      if (currentStep === 5) {
        if (!state.needs.length) { stepError(5, true); return; }
        stepError(5, false);
        pushKlaviyo('Maux', state.needs.join(','));
        save(); showStep(6); return;
      }
    }

    // Cartes radio (sexe, type, zodiac) — auto-avance
    quizz.querySelectorAll('[data-quizz-radios]').forEach(function (group) {
      var name = group.getAttribute('data-quizz-radios');
      group.addEventListener('click', function (e) {
        var card = e.target.closest('.quizz-card');
        if (!card) return;
        group.querySelectorAll('.quizz-card').forEach(function (c) { c.classList.toggle('is-on', c === card); });
        var value = card.getAttribute('data-value');
        if (name === 'sex') {
          state.sex = value; pushKlaviyo('Sexe', value); save();
          setTimeout(function () { showStep(4); }, 220);
        } else if (name === 'illtype') {
          state.illtype = value; state.needs = []; save();
          setTimeout(function () { showStep(5); }, 220);
        } else if (name === 'zodiac') {
          state.zodiac = value; pushKlaviyo('Zodiac_Sign', value); save();
          setTimeout(function () { showStep(7); }, 220);
        }
      });
    });

    // ------------------------------------------------------------ besoins
    function allNeeds() {
      var corps = {}, esprit = {};
      Object.keys(STONES).forEach(function (name) {
        var s = STONES[name];
        var okSex = !s.sexe || !s.sexe.length || s.sexe.some(function (x) {
          return (x || '').toLowerCase() === (state.sex || '').toLowerCase();
        });
        if (!okSex) return;
        (s.corps || []).forEach(function (n) { (corps[n] = corps[n] || []).push(name); });
        (s.esprit || []).forEach(function (n) { (esprit[n] = esprit[n] || []).push(name); });
      });
      return { corps: corps, esprit: esprit };
    }

    var needsExpanded = false;
    function renderNeeds() {
      var box = quizz.querySelector('[data-quizz-needs]');
      var moreBtn = quizz.querySelector('[data-quizz-more]');
      if (!box) return;

      var pools = allNeeds();
      var frSort = function (a, b) { return a.localeCompare(b, 'fr'); };
      var list = [];
      var featured = [];
      if (state.illtype === 'corps' || state.illtype === 'both') {
        Object.keys(pools.corps).sort(frSort).forEach(function (n) { list.push({ name: n, kind: 'c' }); });
        featured = featured.concat(SETTINGS.featuredCorps || []);
      }
      if (state.illtype === 'esprit' || state.illtype === 'both') {
        Object.keys(pools.esprit).sort(frSort).forEach(function (n) { list.push({ name: n, kind: 'e' }); });
        featured = featured.concat(SETTINGS.featuredEsprit || []);
      }
      featured = featured.map(function (x) { return (x || '').trim(); }).filter(Boolean);

      var isFeatured = function (n) {
        return featured.some(function (f) { return f.toLowerCase() === n.toLowerCase(); });
      };
      // Vedettes d'abord (dans l'ordre des réglages), puis le reste replié
      var head = [], tail = [];
      featured.forEach(function (f) {
        var hit = list.filter(function (x) { return x.name.toLowerCase() === f.toLowerCase(); });
        head = head.concat(hit);
      });
      list.forEach(function (x) { if (!isFeatured(x.name)) tail.push(x); });
      if (!head.length) { head = list; tail = []; }

      var html = '';
      var chip = function (x, hiddenExtra) {
        var on = state.needs.indexOf(x.name) !== -1;
        return '<button type="button" class="quizz-chip quizz-chip--' + x.kind + (on ? ' is-on' : '') + (hiddenExtra ? ' quizz-chip--extra' : '') + '" data-need="' + x.name.replace(/"/g, '&quot;') + '">' + x.name + '</button>';
      };
      head.forEach(function (x) { html += chip(x, false); });
      tail.forEach(function (x) { html += chip(x, !needsExpanded); });
      box.innerHTML = html;

      if (moreBtn) {
        moreBtn.hidden = !tail.length || needsExpanded;
        moreBtn.onclick = function () { needsExpanded = true; renderNeeds(); };
      }
      updateNeedCount();
    }

    function updateNeedCount() {
      var el = quizz.querySelector('[data-quizz-need-count]');
      if (el) el.textContent = String(state.needs.length);
    }

    quizz.addEventListener('click', function (e) {
      var chipEl = e.target.closest('.quizz-chip[data-need]');
      if (!chipEl) return;
      var need = chipEl.getAttribute('data-need');
      var i = state.needs.indexOf(need);
      if (i !== -1) {
        state.needs.splice(i, 1);
        chipEl.classList.remove('is-on');
      } else {
        if (state.needs.length >= 4) return;
        state.needs.push(need);
        chipEl.classList.add('is-on');
      }
      stepError(5, false);
      save();
      updateNeedCount();
    });

    // ------------------------------------------- étape email (avant résultat)
    var emailStep = quizz.querySelector('[data-quizz-step="7"]');
    if (emailStep) {
      var emailPercentEl = emailStep.querySelector('[data-quizz-email-percent]');
      if (emailPercentEl && SETTINGS.discountPercent) emailPercentEl.textContent = String(SETTINGS.discountPercent);

      var emailSubmit = emailStep.querySelector('[data-quizz-email-submit]');
      var emailSkip = emailStep.querySelector('[data-quizz-email-skip]');
      var emailInput = emailStep.querySelector('input[name="quizzemail"]');

      if (emailSubmit) emailSubmit.addEventListener('click', function (e) {
        e.preventDefault();
        var v = (emailInput && emailInput.value || '').trim();
        var ok = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v);
        emailStep.classList.toggle('has-error', !ok);
        if (!ok) return;
        state.email = v; save();
        // Re-pousser TOUTES les réponses : le formulaire Klaviyo a pu être
        // rendu après les premières étapes du quizz
        pushKlaviyo('first_name', state.firstname);
        pushKlaviyo('Sexe', state.sex);
        pushKlaviyo('Zodiac_Sign', state.zodiac);
        pushKlaviyo('Maux', state.needs.join(','));
        pushKlaviyo('email', v);
        submitKlaviyo();
        showResult();
      });
      if (emailSkip) emailSkip.addEventListener('click', function (e) {
        e.preventDefault();
        showResult();
      });
      if (emailInput) emailInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); emailSubmit && emailSubmit.click(); }
      });
    }

    // ----------------------------------------------------- recommandation
    // Couverture maximale : à chaque tour, la pierre qui couvre le plus de
    // besoins restants (départage alphabétique → stable).
    function recommendStones() {
      var pools = allNeeds();
      var candidates = {};
      state.needs.forEach(function (need) {
        (pools.corps[need] || []).concat(pools.esprit[need] || []).forEach(function (stone) {
          (candidates[stone] = candidates[stone] || []).push(need);
        });
      });

      // Proposition 1 « L'Essentielle » : couverture maximale, minimum de pierres
      var remaining = state.needs.slice();
      var picked = [];
      while (remaining.length && picked.length < 4) {
        var bestStone = null, bestCover = [];
        Object.keys(candidates).sort(function (a, b) { return a.localeCompare(b, 'fr'); }).forEach(function (stone) {
          if (picked.some(function (p) { return p.name === stone; })) return;
          var cover = candidates[stone].filter(function (n) { return remaining.indexOf(n) !== -1; });
          if (cover.length > bestCover.length) { bestStone = stone; bestCover = cover; }
        });
        if (!bestStone) break;
        picked.push({ name: bestStone, needs: bestCover });
        remaining = remaining.filter(function (n) { return bestCover.indexOf(n) === -1; });
      }

      // Proposition 2 « La Généreuse » : une pierre différente par besoin (variété)
      var inA = picked.map(function (p) { return p.name; });
      var alt = [];
      state.needs.forEach(function (need) {
        if (alt.length >= 4) return;
        if (alt.some(function (p) { return p.needs.indexOf(need) !== -1; })) return;
        var options = (candidates && Object.keys(candidates).filter(function (stone) {
          return candidates[stone].indexOf(need) !== -1;
        })) || [];
        options.sort(function (a, b) {
          var aInA = inA.indexOf(a) !== -1 ? 1 : 0;
          var bInA = inA.indexOf(b) !== -1 ? 1 : 0;
          if (aInA !== bInA) return aInA - bInA; // privilégier les pierres absentes de la prop. 1
          return a.localeCompare(b, 'fr');
        });
        var chosen = null;
        for (var oi = 0; oi < options.length; oi++) {
          var existing = null;
          for (var ai = 0; ai < alt.length; ai++) { if (alt[ai].name === options[oi]) { existing = alt[ai]; break; } }
          if (existing) { existing.needs.push(need); chosen = existing; break; }
          chosen = { name: options[oi], needs: [need] };
          alt.push(chosen);
          break;
        }
      });

      var sameComposition = alt.length === picked.length && alt.every(function (p) {
        return picked.some(function (q) { return q.name === p.name; });
      });
      return sameComposition ? [picked] : [picked, alt];
    }

    // --------------------------------------------------------- résultat
    var LOADER_LINES = [
      'Analyse de tes besoins…',
      'Sélection parmi 31 pierres naturelles…',
      'Composition de ton bracelet…'
    ];

    function showResult() {
      state.proposals = recommendStones();
      state.proposal = 0;
      state.stones = state.proposals[0] || [];
      state.astroAdded = false;
      pushKlaviyo('Pierres', state.stones.map(function (s) { return s.name; }).join(','));
      save();

      steps.forEach(function (s) { s.hidden = true; });
      if (progress) progress.hidden = true;
      finalStep.hidden = false;

      var loader = finalStep.querySelector('.quizz-final-loader-wrapper');
      var content = finalStep.querySelector('.quizz-final-content');
      var label = finalStep.querySelector('[data-quizz-loader-label]');
      loader.style.display = '';
      content.hidden = true;

      var li = 0;
      var cycle = setInterval(function () {
        li++;
        if (label && LOADER_LINES[li]) label.textContent = LOADER_LINES[li];
      }, 800);

      setTimeout(function () {
        clearInterval(cycle);
        loader.style.display = 'none';
        content.hidden = false;
        renderResult();
        startOffer();
      }, 2400);
    }

    function compositionStones() {
      var names = state.stones.map(function (s) { return s.name; });
      if (state.astroAdded) {
        var z = ZODIAC[state.zodiac];
        if (z && names.indexOf(z.stone) === -1 && names.length < 4) names.push(z.stone);
      }
      return names.slice(0, 4);
    }

    function renderResult() {
      var nameEl = finalStep.querySelector('[data-quizz-firstname-final]');
      if (nameEl) nameEl.textContent = state.firstname || 'Voici';

      renderProposals();
      launchConfetti();

      // Pierres + besoins couverts
      var stonesBox = finalStep.querySelector('[data-quizz-stones]');
      if (stonesBox) {
        stonesBox.innerHTML = state.stones.map(function (s) {
          var d = STONES[s.name] || {};
          return '<div class="quizz-stone">' +
            '<img src="' + (d.vignette || '') + '" alt="' + s.name + '" class="quizz-stone__img">' +
            '<div class="quizz-stone__txt"><strong>' + s.name + '</strong>' +
            '<span>pour ' + s.needs.join(', ').toLowerCase() + '</span></div>' +
            '</div>';
        }).join('');
      }

      renderAstro();
      renderBracelet();
      updatePrice();
      updateCustomizeLink();
    }

    // Deux propositions de composition
    function renderProposals() {
      var box = finalStep.querySelector('[data-quizz-proposals]');
      if (!box) return;
      if (!state.proposals || state.proposals.length < 2) { box.hidden = true; return; }
      box.hidden = false;
      var labels = ['Version 1', 'Version 2'];
      box.innerHTML = state.proposals.map(function (prop, i) {
        return '<button type="button" class="quizz-proposal' + (i === state.proposal ? ' is-on' : '') + '" data-quizz-proposal="' + i + '">' +
          labels[i] + '</button>';
      }).join('');
    }

    finalStep.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-quizz-proposal]');
      if (!tab) return;
      var i = parseInt(tab.getAttribute('data-quizz-proposal'), 10);
      if (isNaN(i) || !state.proposals[i] || i === state.proposal) return;
      state.proposal = i;
      state.stones = state.proposals[i];
      state.astroAdded = false;
      pushKlaviyo('Pierres', state.stones.map(function (s) { return s.name; }).join(','));
      save();
      renderProposals();
      var stonesBox = finalStep.querySelector('[data-quizz-stones]');
      if (stonesBox) {
        stonesBox.innerHTML = state.stones.map(function (s) {
          var d = STONES[s.name] || {};
          return '<div class="quizz-stone">' +
            '<img src="' + (d.vignette || '') + '" alt="' + s.name + '" class="quizz-stone__img">' +
            '<div class="quizz-stone__txt"><strong>' + s.name + '</strong>' +
            '<span>pour ' + s.needs.join(', ').toLowerCase() + '</span></div>' +
            '</div>';
        }).join('');
      }
      renderAstro();
      renderBracelet();
      updatePrice();
      updateCustomizeLink();
    });

    // Confettis sobres à l'arrivée du résultat (désactivés si reduced motion)
    function launchConfetti() {
      var box = finalStep.querySelector('[data-quizz-confetti]');
      if (!box) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var colors = ['#d9b78a', '#e8cfa8', '#c9a5a0', '#b8a690', '#e6d9c5'];
      var html = '';
      for (var i = 0; i < 26; i++) {
        var left = (i * 137) % 100;                    // répartition pseudo-aléatoire stable
        var delay = ((i * 53) % 40) / 100;
        var dur = 1.6 + ((i * 29) % 90) / 100;
        var size = 5 + ((i * 17) % 6);
        var color = colors[i % colors.length];
        html += '<span style="left:' + left + '%;width:' + size + 'px;height:' + (size * 0.45) + 'px;' +
          'background:' + color + ';animation-delay:' + delay + 's;animation-duration:' + dur + 's;"></span>';
      }
      box.innerHTML = html;
      setTimeout(function () { box.innerHTML = ''; }, 3200);
    }

    // Astro upsell
    function renderAstro() {
      var box = finalStep.querySelector('[data-quizz-astro]');
      var z = ZODIAC[state.zodiac];
      if (!box || !z || !STONES[z.stone]) { if (box) box.hidden = true; return; }
      box.hidden = false;

      var inReco = state.stones.some(function (s) { return s.name === z.stone; });
      if (inReco) {
        box.innerHTML = '<p class="quizz-astro__in">✨ Bonne nouvelle : ton bracelet contient déjà ta pierre de naissance, la <strong>' + z.stone + '</strong> (' + z.label + ').</p>';
        return;
      }
      // Bracelet complet (4 pierres) : pas de place pour l'upsell
      if (state.stones.length >= 4) { box.hidden = true; return; }
      var price = (STONES[z.stone].supplementPriceCents || 0) / 100;
      var priceTxt = price ? ' · +' + price.toFixed(2).replace('.', ',') + ' €' : '';
      box.innerHTML =
        '<div class="quizz-astro__card' + (state.astroAdded ? ' is-on' : '') + '">' +
        '<img src="' + (STONES[z.stone].vignette || '') + '" alt="' + z.stone + '" class="quizz-astro__img">' +
        '<div class="quizz-astro__txt">' +
        '<strong>✨ Ta pierre de naissance : ' + z.stone + '</strong>' +
        '<span>Accordée à ton signe ' + z.label + ', elle ' + z.arg + ' et amplifie l’action des autres pierres.</span>' +
        '</div>' +
        '<button type="button" class="quizz-astro__btn" data-quizz-astro-toggle>' +
        (state.astroAdded ? 'Ajoutée ✓' : '+ L’ajouter' + priceTxt) + '</button>' +
        '</div>';
    }

    finalStep.addEventListener('click', function (e) {
      if (e.target.closest('[data-quizz-astro-toggle]')) {
        state.astroAdded = !state.astroAdded;
        save();
        renderAstro();
        renderBracelet();
        updatePrice();
        updateCustomizeLink();
      }
    });

    // ------------------------------------------- maquette réaliste (bridge)
    function renderBracelet() {
      var wrapper = finalStep.querySelector('[data-quizz-bracelet]');
      if (!wrapper) return;
      wrapper.innerHTML = '';
      var backdrop = quizz.getAttribute('data-backdrop');
      if (backdrop) wrapper.style.backgroundImage = 'url(' + backdrop + ')';

      var textures = compositionStones().map(function (n) {
        return (STONES[n] || {}).texture;
      }).filter(Boolean);

      var beadsNumber = (SIZE_CONFIG[state.beadSize] || {})[state.braceletSize] || 31;
      var containerWidth = wrapper.clientWidth || 420;
      var beadUnit = (containerWidth * 0.70 * Math.PI) / 31;
      var mmFactor = (state.beadSize === '8mm') ? (8 / 6) : 1;
      var diametreBead = beadUnit * mmFactor;
      var diametreBracelet = (diametreBead * beadsNumber) / Math.PI;
      var maxStage = containerWidth * 0.98;
      var projected = diametreBracelet + diametreBead * 1.18;
      if (projected > maxStage) {
        var shrink = maxStage / projected;
        diametreBead *= shrink;
        diametreBracelet *= shrink;
      }
      var ELLIPSE_RATIO = 0.52, SCALE_BACK = 0.80, SCALE_FRONT = 1.18;
      var rx = diametreBracelet / 2, ry = rx * ELLIPSE_RATIO;
      var stageWidth = diametreBracelet + diametreBead * SCALE_FRONT;
      var stageHeight = ry * 2 + diametreBead * SCALE_FRONT * 1.4;
      var centerX = stageWidth / 2, centerY = stageHeight / 2;

      var stage = document.createElement('div');
      stage.className = 'quizz-bracelet-stage';
      stage.style.cssText = 'width:' + stageWidth + 'px;height:' + stageHeight + 'px;position:absolute;left:50%;top:55%;transform:translate(-50%,-50%);';

      var SAMPLES = 1440, samples = [], totalWeighted = 0, bottomCum = 0;
      var s, th, dsdth, sDepth, w;
      for (s = 0; s < SAMPLES; s++) {
        th = (s / SAMPLES) * Math.PI * 2;
        dsdth = Math.sqrt(Math.pow(rx * Math.sin(th), 2) + Math.pow(ry * Math.cos(th), 2)) * (Math.PI * 2 / SAMPLES);
        sDepth = (Math.sin(th) + 1) / 2;
        w = SCALE_BACK + (SCALE_FRONT - SCALE_BACK) * sDepth;
        totalWeighted += dsdth / w;
        samples.push({ th: th, cum: totalWeighted });
        if (th <= Math.PI / 2) bottomCum = totalWeighted;
      }
      var step = totalWeighted / beadsNumber;
      var baseBead = step * 1.06;
      function angleAt(cumTarget) {
        cumTarget = ((cumTarget % totalWeighted) + totalWeighted) % totalWeighted;
        for (var k = 0; k < SAMPLES; k++) { if (samples[k].cum >= cumTarget) return samples[k].th; }
        return samples[SAMPLES - 1].th;
      }
      var backIndex = Math.floor(beadsNumber / 2);
      for (var i = 0; i < beadsNumber; i++) {
        var angle = angleAt(bottomCum + i * step);
        var x = centerX + rx * Math.cos(angle);
        var y = centerY + ry * Math.sin(angle);
        var depth = (Math.sin(angle) + 1) / 2;
        var beadSize = baseBead * (SCALE_BACK + (SCALE_FRONT - SCALE_BACK) * depth);
        var bead = document.createElement('span');
        bead.className = 'dynamic-bracelet__bead quizz-bead';
        bead.style.top = (y - beadSize / 2) + 'px';
        bead.style.left = (x - beadSize / 2) + 'px';
        bead.style.width = beadSize + 'px';
        bead.style.height = beadSize + 'px';
        bead.style.zIndex = String(10 + Math.round(depth * 100));
        if (textures.length) {
          var patternPos = (i - backIndex + beadsNumber) % beadsNumber;
          bead.style.backgroundImage = 'url(' + textures[patternPos % textures.length] + ')';
        }
        stage.appendChild(bead);
      }
      wrapper.appendChild(stage);
    }

    // ------------------------------------------------------- tailles + prix
    function bindPills(attr, key, after) {
      var group = finalStep.querySelector('[' + attr + ']');
      if (!group) return;
      group.addEventListener('click', function (e) {
        var pill = e.target.closest('.quizz-pill');
        if (!pill) return;
        group.querySelectorAll('.quizz-pill').forEach(function (p) { p.classList.toggle('is-on', p === pill); });
        state[key] = pill.getAttribute('data-value');
        save();
        after();
      });
    }
    bindPills('data-quizz-beadsize', 'beadSize', function () { renderBracelet(); updatePrice(); });
    bindPills('data-quizz-braceletsize', 'braceletSize', function () { renderBracelet(); updatePrice(); });

    function totalCents() {
      var key = state.beadSize + '/' + state.braceletSize;
      var v = BRACELET_VARIANTS[key];
      var total = v ? v.priceCents : 0;
      compositionStones().forEach(function (n) {
        total += (STONES[n] || {}).supplementPriceCents || 0;
      });
      return total;
    }

    function euros(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function updatePrice() {
      var normalRow = finalStep.querySelector('[data-quizz-offer-normal]');
      var oldEl = finalStep.querySelector('[data-quizz-price-old]');
      var newEl = finalStep.querySelector('[data-quizz-price-new]');
      var labelEl = finalStep.querySelector('[data-quizz-price-label]');
      var total = totalCents();
      var pct = SETTINGS.discountPercent || 0;
      var active = offerActive() && SETTINGS.discountCode;

      if (active && pct > 0) {
        if (normalRow) normalRow.hidden = false;
        if (oldEl) oldEl.textContent = euros(total);
        if (labelEl) labelEl.innerHTML = 'Ton prix quizz <em>-' + pct + '&nbsp;%</em>';
        if (newEl) newEl.textContent = euros(Math.round(total * (100 - pct) / 100));
      } else {
        if (normalRow) normalRow.hidden = true;
        if (labelEl) labelEl.textContent = 'Prix';
        if (newEl) newEl.textContent = euros(total);
      }
    }

    // ------------------------------------------------------------- l'offre
    var timerInterval = null;

    function offerDeadline() {
      var v = parseInt(sessionStorage.getItem('quizzOfferEnd') || '0', 10);
      return isNaN(v) ? 0 : v;
    }

    function offerActive() {
      return !!SETTINGS.discountCode && offerDeadline() > Date.now();
    }

    function startOffer() {
      if (!SETTINGS.discountCode) return;
      // Chaque nouveau résultat de quizz relance une offre fraîche.
      // Le code promo n'est PAS posé ici : uniquement au clic « Ajouter au
      // panier » (sinon le cookie Shopify persiste 14 jours et le -20 %
      // s'applique à toutes les commandes suivantes du visiteur).
      sessionStorage.setItem('quizzOfferEnd', String(Date.now() + (SETTINGS.timerMinutes || 15) * 60000));
      var timerEl = finalStep.querySelector('[data-quizz-timer]');
      var valueEl = finalStep.querySelector('[data-quizz-timer-value]');
      if (timerInterval) clearInterval(timerInterval);
      var tick = function () {
        var left = offerDeadline() - Date.now();
        if (left <= 0) {
          clearInterval(timerInterval);
          if (timerEl) timerEl.hidden = true;
          updatePrice();
          return;
        }
        if (timerEl) timerEl.hidden = false;
        if (valueEl) {
          var m = Math.floor(left / 60000);
          var sec = Math.floor((left % 60000) / 1000);
          valueEl.textContent = m + ':' + (sec < 10 ? '0' : '') + sec;
        }
      };
      tick();
      timerInterval = setInterval(tick, 1000);
      updatePrice();
    }

    // -------------------------------------------------------- lien configurateur
    function updateCustomizeLink() {
      var link = finalStep.querySelector('[data-quizz-customize]');
      if (!link) return;
      var url = SETTINGS.productUrl || '/products/produit-personnalise';
      var names = compositionStones();
      var params = [];
      names.slice(0, 4).forEach(function (n, i) {
        params.push('b' + (i + 1) + '=' + encodeURIComponent(n));
      });
      var relative = url + (params.length ? '?' + params.join('&') : '');
      link.setAttribute('href', relative);
      try { sessionStorage.setItem('quizzBeads', JSON.stringify(names.slice(0, 4))); } catch (e) {}
      // Le formulaire Klaviyo est déjà soumis à ce stade : on remonte la
      // composition directement sur le profil (sinon Pierres reste vide)
      if (state.email && names.length) {
        identifyKlaviyo({
          '$email': state.email,
          'Pierres': names.slice(0, 4).join(', '),
          'Bracelet_URL': window.location.origin + relative
        });
      }
    }

    // ------------------------------------------------------ ajout au panier
    var atcBtn = finalStep.querySelector('[data-quizz-atc]');
    if (atcBtn) atcBtn.addEventListener('click', addToCart);

    function addToCart() {
      var names = compositionStones().slice(0, 4);
      if (!names.length) return;

      var key = state.beadSize + '/' + state.braceletSize;
      var braceletVariant = BRACELET_VARIANTS[key];
      if (!braceletVariant) { alert('Combinaison de tailles introuvable, réessaie.'); return; }

      // Poser le code promo uniquement maintenant, et seulement si l'offre court encore
      if (offerActive()) {
        fetch('/discount/' + encodeURIComponent(SETTINGS.discountCode)).catch(function () {});
      }

      var groupId = Date.now().toString();
      var braceletProps = { '_bracelet_group': groupId };
      names.forEach(function (n, i) { braceletProps['Perle ' + (i + 1)] = n; });
      braceletProps['Taille des perles'] = state.beadSize;
      braceletProps['Taille du bracelet'] = state.braceletSize;

      var items = [{ id: braceletVariant.id, quantity: 1, properties: braceletProps }];
      names.forEach(function (n, i) {
        var sv = (STONES[n] || {}).supplementVariantId;
        if (sv) {
          items.push({
            id: sv,
            quantity: 1,
            properties: { '_bracelet_group': groupId, '_slot': String(i + 1), '_stone': n }
          });
        }
      });

      atcBtn.disabled = true;

      var cartItemsComp = document.querySelector('cart-items-component');
      var cartSectionId = cartItemsComp ? cartItemsComp.dataset.sectionId : '';
      var requestBody = { items: items };
      if (cartSectionId) {
        requestBody.sections = cartSectionId;
        requestBody.sections_url = window.location.pathname;
      }

      var resolveLinesUpdate;
      var linesUpdatePromise = new Promise(function (res) { resolveLinesUpdate = res; });
      var linesEvent = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
      linesEvent.action = 'add';
      linesEvent.context = 'product';
      linesEvent.promise = linesUpdatePromise;
      document.dispatchEvent(linesEvent);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody)
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function (data) {
          return fetch('/cart.js').then(function (r) { return r.json(); })
            .then(function (cart) { return { data: data, cart: cart }; })
            .catch(function () { return { data: data, cart: null }; });
        })
        .then(function (result) {
          var sections = result.data && result.data.sections ? result.data.sections : null;
          var visibleCount;
          if (result.cart) {
            visibleCount = result.cart.items.reduce(function (acc, it) {
              return acc + (it.handle === 'supplement-pierre-bracelet' ? 0 : it.quantity);
            }, 0);
          }
          resolveLinesUpdate({ detail: { sections: sections || undefined, itemCount: visibleCount } });
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { data: { sourceId: 'quizz' } }
          }));
          var themeDrawer = document.getElementById('cart-drawer');
          if (themeDrawer && typeof themeDrawer.open === 'function' && !themeDrawer.hasAttribute('open')) {
            themeDrawer.open();
          }
        })
        .catch(function (err) {
          console.error('Quizz: erreur ajout panier', err);
          resolveLinesUpdate({ detail: { didError: true } });
          alert('Une erreur est survenue lors de l’ajout au panier. Réessaie.');
        })
        .finally(function () { atcBtn.disabled = false; });
    }

    // ------------------------------------------------------------- Klaviyo
    // Mise à jour du profil hors formulaire (script onsite Klaviyo).
    // Sert pour tout ce qui est calculé APRÈS la soumission du formulaire.
    function identifyKlaviyo(props) {
      try {
        window._learnq = window._learnq || [];
        window._learnq.push(['identify', props]);
      } catch (e) {}
    }

    function pushKlaviyo(idPart, value) {
      var klaviyoForm = klForm();
      if (!klaviyoForm) return;
      try {
        var field = klaviyoForm.querySelector('[id*="' + idPart + '"]');
        if (field) {
          // Setter natif : indispensable pour que React (formulaires Klaviyo)
          // prenne en compte une valeur posée par script
          var proto = field.tagName === 'TEXTAREA' ? window.HTMLTextAreaElement : window.HTMLInputElement;
          var setter = Object.getOwnPropertyDescriptor(proto.prototype, 'value').set;
          setter.call(field, value);
          field.dispatchEvent(new Event('input', { bubbles: true }));
          field.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } catch (e) {}
    }

    function submitKlaviyo() {
      var klaviyoForm = klForm();
      if (!klaviyoForm) return;
      try {
        // Cliquer le vrai bouton du formulaire (React ignore un submit synthétique)
        var btn = klaviyoForm.querySelector('button[type="submit"], [type="submit"]');
        if (btn) { btn.click(); return; }
        var form = klaviyoForm.querySelector('form');
        if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      } catch (e) {}
    }

    // ------------------------------------------------------------- démarrage
    showStep(1);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
